import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconShareDoc } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { toggleSidePanelApp } from '../../../side-panel/actions';
import { SidePanelTabId } from '../../../side-panel/constants';
import { isSidePanelTabOpen } from '../../../side-panel/functions';
import { isFileSharingEnabled } from '../../functions.any';
/**
 * Component that renders a button to open the file sharing panel.
 *
 * @augments AbstractButton
 */
class FileSharingButton extends AbstractButton {
    icon = IconShareDoc;
    label = 'toolbar.fileSharing';
    tooltip = 'toolbar.fileSharing';
    /**
     * {@inheritdoc}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Handles clicking the button to open the file sharing panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        dispatch(toggleSidePanelApp(SidePanelTabId.FILE_SHARING));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {Object} - Mapped props.
 */
function mapStateToProps(state) {
    return {
        _isOpen: isSidePanelTabOpen(state, SidePanelTabId.FILE_SHARING),
        visible: isFileSharingEnabled(state)
    };
}
export default translate(connect(mapStateToProps)(FileSharingButton));
